import actionTypes from 'dashboard/actions/net-sales/action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_NET_SALES_DETAILS_SUCCESS:
      return { ...action.netSalesDetails.instantGames };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/net-sales/instant-games.js